export function geoRev (obj) {
  if (!obj) return obj

  const coordinates = obj.location.coordinates.reverse()
  obj.location.coordinates = coordinates
  return obj
}

export function geoRevs (arr) {
  return arr.map(x => {
    x.location.coordinates =
      x.location.coordinates.reverse()
    return x
  })
}
